var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_c('div',{staticClass:"footer-main"},[_c('span',[_vm._v("版权所有©财讯平台 青峰见网络科技（苏州）有限公司 ")]),_c('img',{attrs:{"src":require("../../static/icon/beian.png")}}),_c('span',[_vm._v("苏公网安备32059002004804号")]),_c('span',[_vm._v("苏ICP备2021012769号-2")])])])
}]

export { render, staticRenderFns }